/**
 * ユーティリティ
 */

/**
 * 任意の桁で四捨五入する関数
 * @param {number} value 四捨五入する数値
 * @param {number} base どの桁で四捨五入するか（10→10の位、0.1→小数第１位）
 * @return {number} 四捨五入した値
 */
export function orgRound(value, base) {
    return Math.round(value * base) / base;
}
